<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'

// Pinia Store
const userStore = useUserStore()

// Computed Property for User Preference
const twigMode = computed(() => {
    return userStore.pref('codeMirror_twigMode')
})

// Methods
const setPref = () => {
    userStore.setPref({
        name: 'codeMirror_twigMode',
        value: !twigMode.value
    })
}
</script>

<template>
    <button class="dropdown-item" type="button" @click="setPref">
        <span
            :class="{ 'bi-square': !twigMode, 'bi-check-square': twigMode }"
            class="me-2"
        />
        Highlight Twig code
    </button>
</template>